import {
  ChargeBeePlan,
  PlanName,
  ChargeBeeAddonId,
  ChargeBeePlanId,
  CacheLocation,
  Support,
  BillingPeriod,
  PlanTier,
} from './types';

const tier2025ChargeBeePlans: Array<ChargeBeePlan> = [
  {
    // used only for testing with reduced render limits
    name: PlanName.StarterStaging,
    chargeBeePlanId: ChargeBeePlanId.StarterStaging,
    index: 1,
    legacy: false,
    costInCents: 4900,
    addonCostInCents: 200,
    currencyCode: 'USD',
    includedRenderedPages: 1000,
    chargeBeeAddonId: ChargeBeeAddonId.starterStagingOverages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 7],
    cacheLocation: CacheLocation.shared,
    sitemapRevisitInterval: [168, 168],
    dataRetentionDays: 60,
    available: false,
    support: Support.low,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: false,
    domainSchedulerSettingsMaxRules: 0,
    dashboardAlerts: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Starter,
    chargeBeePlanId: ChargeBeePlanId.Starter,
    index: 1,
    legacy: false,
    costInCents: 4900,
    addonCostInCents: 200,
    currencyCode: 'USD',
    includedRenderedPages: 25000,
    chargeBeeAddonId: ChargeBeeAddonId.starter2025Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 7],
    cacheLocation: CacheLocation.shared,
    sitemapRevisitInterval: [168, 168],
    dataRetentionDays: 60,
    available: false,
    support: Support.low,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: false,
    domainSchedulerSettingsMaxRules: 0,
    dashboardAlerts: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    // used only for testing with reduced render limits
    name: PlanName.GrowthStaging,
    chargeBeePlanId: ChargeBeePlanId.GrowthStaging,
    index: 2,
    legacy: false,
    costInCents: 14900,
    addonCostInCents: 150,
    currencyCode: 'USD',
    includedRenderedPages: 2000,
    chargeBeeAddonId: ChargeBeeAddonId.growthStagingOverages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.5, 14],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [24, 168],
    dataRetentionDays: 180,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 0,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Growth,
    chargeBeePlanId: ChargeBeePlanId.Growth,
    index: 2,
    legacy: false,
    costInCents: 14900,
    addonCostInCents: 150,
    currencyCode: 'USD',
    includedRenderedPages: 100000,
    chargeBeeAddonId: ChargeBeeAddonId.growth2025Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.5, 14],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [24, 168],
    dataRetentionDays: 180,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 0,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Pro,
    chargeBeePlanId: ChargeBeePlanId.Pro,
    index: 3,
    legacy: false,
    costInCents: 34900,
    addonCostInCents: 125,
    currencyCode: 'USD',
    includedRenderedPages: 500000,
    chargeBeeAddonId: ChargeBeeAddonId.pro2025Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [8, 168],
    dataRetentionDays: 730,
    available: false,
    support: Support.high,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 5,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 1,
  },
  {
    name: PlanName.EnterprisePlus,
    chargeBeePlanId: ChargeBeePlanId.EnterprisePlus,
    index: 4,
    legacy: false,
    costInCents: 100000, // $1000
    addonCostInCents: 125, // $1.25 per 1000 renders
    currencyCode: 'USD',
    includedRenderedPages: 1000000,
    chargeBeeAddonId: ChargeBeeAddonId.enterprisePlus2025Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [1, 168],
    dataRetentionDays: 730,
    dataRetentionDaysExport: 'all-time',
    available: false,
    support: Support.enterprise,
    billingPeriod: BillingPeriod.monthly,
    customPlan: true,
    contactUsToUse: true,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 10,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 5,
  },
  {
    name: PlanName.EnterprisePlusYearly,
    chargeBeePlanId: ChargeBeePlanId.EnterprisePlusYearly,
    index: 5,
    legacy: false,
    costInCents: 100000, // $1000
    addonCostInCents: 125, // $1.25 per 1000 renders
    currencyCode: 'USD',
    includedRenderedPages: 1000000,
    chargeBeeAddonId: ChargeBeeAddonId.enterprisePlusYearly2025Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [1, 168],
    dataRetentionDays: 730,
    dataRetentionDaysExport: 'all-time',
    available: false,
    support: Support.enterprise,
    billingPeriod: BillingPeriod.yearly,
    customPlan: true,
    contactUsToUse: true,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 10,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 5,
  },
  {
    name: PlanName.CustomEnterprise3Years,
    chargeBeePlanId: ChargeBeePlanId.CustomEnterprise3Years,
    index: 5,
    legacy: false,
    costInCents: 100000, // $1000
    addonCostInCents: 80, // $0.80 per 1000 renders
    currencyCode: 'USD',
    includedRenderedPages: 72000001,
    chargeBeeAddonId: ChargeBeeAddonId.enterprisePlusYearly2025Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [1, 168],
    dataRetentionDays: 730,
    dataRetentionDaysExport: 'all-time',
    available: false,
    support: Support.enterprise,
    billingPeriod: BillingPeriod.yearly,
    customPlan: true,
    contactUsToUse: true,
    tier: PlanTier.P2025,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 10,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 5,
  },
  {
    name: PlanName.POC,
    chargeBeePlanId: ChargeBeePlanId.POC,
    index: 5,
    legacy: false,
    costInCents: 0,
    addonCostInCents: 0,
    currencyCode: 'USD',
    includedRenderedPages: 0,
    chargeBeeAddonId: undefined,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    sitemapRevisitInterval: [1, 168],
    dataRetentionDays: 730,
    available: false,
    support: Support.enterprise,
    billingPeriod: BillingPeriod.monthly,
    customPlan: true,
    contactUsToUse: true,
    tier: PlanTier.Custom,
    apiAccess: true,
    auditLog: true,
    domainSchedulerSettingsMaxRules: 10,
    dashboardAlerts: true,
    searchPerformanceMaxDomains: 5,
  },
];

const tier2024ChargeBeePlans: Array<ChargeBeePlan> = [
  {
    name: PlanName.Lite,
    chargeBeePlanId: ChargeBeePlanId.Lite2024,
    index: 2,
    legacy: false,
    costInCents: 3000,
    addonCostInCents: 185,
    currencyCode: 'USD',
    includedRenderedPages: 15000,
    chargeBeeAddonId: ChargeBeeAddonId.lite2024Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 7],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2024,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Essential,
    chargeBeePlanId: ChargeBeePlanId.Essential2024,
    index: 3,
    legacy: false,
    costInCents: 9000,
    addonCostInCents: 150,
    currencyCode: 'USD',
    includedRenderedPages: 50000,
    chargeBeeAddonId: ChargeBeeAddonId.essential2024Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 7],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2024,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Advanced,
    chargeBeePlanId: ChargeBeePlanId.Advanced2024,
    index: 4,
    legacy: false,
    costInCents: 29000,
    addonCostInCents: 100,
    currencyCode: 'USD',
    includedRenderedPages: 250000,
    chargeBeeAddonId: ChargeBeeAddonId.advanced2024Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.5, 14],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2024,
    apiAccess: true,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Custom,
    chargeBeePlanId: ChargeBeePlanId.Custom2024,
    index: 5,
    legacy: false,
    costInCents: 990000,
    addonCostInCents: 75,
    currencyCode: 'USD',
    includedRenderedPages: 1000000,
    chargeBeeAddonId: ChargeBeeAddonId.custom2024Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.high,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: true,
    tier: PlanTier.P2024,
    apiAccess: true,
    domainSchedulerSettingsMaxRules: 10,
    searchPerformanceMaxDomains: 5,
  },
];

export const chargeBeePlans: Array<ChargeBeePlan> = [
  {
    name: PlanName.Legacy,
    chargeBeePlanId: ChargeBeePlanId.Legacy,
    index: 0,
    legacy: true,
    costInCents: 0,
    addonCostInCents: 0,
    currencyCode: 'USD',
    includedRenderedPages: 0,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 90],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.none,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.Legacy,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.LegacyYearly,
    chargeBeePlanId: ChargeBeePlanId.LegacyYearly,
    index: 1,
    legacy: true,
    costInCents: 0,
    addonCostInCents: 0,
    currencyCode: 'USD',
    includedRenderedPages: 0,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 90],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.none,
    billingPeriod: BillingPeriod.yearly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.Legacy,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Basic,
    chargeBeePlanId: ChargeBeePlanId.Basic,
    index: 0,
    legacy: false,
    costInCents: 0,
    addonCostInCents: 0,
    currencyCode: 'USD',
    includedRenderedPages: 1000,
    suggested: false,
    current: false,
    cacheRefreshInterval: [3, 3],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.none,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.Free,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Professional,
    chargeBeePlanId: ChargeBeePlanId.Professional,
    index: 1,
    legacy: false,
    costInCents: 2500,
    addonCostInCents: 200,
    includedRenderedPages: 50000,
    currencyCode: 'USD',
    chargeBeeAddonId: ChargeBeeAddonId.professionalOverages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [3, 90],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.none,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2020,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Startup,
    chargeBeePlanId: ChargeBeePlanId.Startup,
    index: 2,
    legacy: false,
    costInCents: 9900,
    addonCostInCents: 100,
    currencyCode: 'USD',
    includedRenderedPages: 250000,
    chargeBeeAddonId: ChargeBeeAddonId.startupOverages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 90],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.low,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2020,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Business,
    chargeBeePlanId: ChargeBeePlanId.Business,
    index: 3,
    legacy: false,
    costInCents: 29900,
    addonCostInCents: 75,
    currencyCode: 'USD',
    includedRenderedPages: 3000000,
    chargeBeeAddonId: ChargeBeeAddonId.businessOverages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 90],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2020,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Enterprise,
    chargeBeePlanId: ChargeBeePlanId.Enterprise,
    index: 4,
    legacy: false,
    costInCents: 199000,
    addonCostInCents: 20,
    currencyCode: 'USD',
    includedRenderedPages: 10000000,
    chargeBeeAddonId: ChargeBeeAddonId.enterpriseOverages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 90],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.high,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: true,
    tier: PlanTier.P2020,
    apiAccess: true,
    domainSchedulerSettingsMaxRules: 10,
    searchPerformanceMaxDomains: 5,
  },
  {
    name: PlanName.Startup,
    chargeBeePlanId: ChargeBeePlanId.Startup2022,
    index: 2,
    legacy: false,
    costInCents: 9000,
    addonCostInCents: 200,
    currencyCode: 'USD',
    includedRenderedPages: 100000,
    chargeBeeAddonId: ChargeBeeAddonId.startup2022Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [1, 7],
    cacheLocation: CacheLocation.shared,
    available: false,
    support: Support.low,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2022,
    apiAccess: false,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Scaleup,
    chargeBeePlanId: ChargeBeePlanId.Scaleup2022,
    index: 3,
    legacy: false,
    costInCents: 29000,
    addonCostInCents: 100,
    currencyCode: 'USD',
    includedRenderedPages: 1000000,
    chargeBeeAddonId: ChargeBeeAddonId.scaleup2022Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.5, 14],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.normal,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: false,
    tier: PlanTier.P2022,
    apiAccess: true,
    searchPerformanceMaxDomains: 0,
  },
  {
    name: PlanName.Enterprise,
    chargeBeePlanId: ChargeBeePlanId.Enterprise2022,
    index: 4,
    legacy: false,
    costInCents: 99000,
    addonCostInCents: 50,
    currencyCode: 'USD',
    includedRenderedPages: 5000000,
    chargeBeeAddonId: ChargeBeeAddonId.enterprise2022Overages,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.high,
    billingPeriod: BillingPeriod.monthly,
    customPlan: false,
    contactUsToUse: true,
    tier: PlanTier.P2022,
    apiAccess: true,
    domainSchedulerSettingsMaxRules: 10,
    searchPerformanceMaxDomains: 5,
  },
  {
    name: PlanName.CustomEnterprise,
    chargeBeePlanId: ChargeBeePlanId.CustomEnterprise,
    index: 5,
    legacy: false,
    costInCents: 0,
    addonCostInCents: 0,
    currencyCode: 'USD',
    includedRenderedPages: 0,
    chargeBeeAddonId: undefined,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.high,
    billingPeriod: BillingPeriod.monthly,
    customPlan: true,
    contactUsToUse: false,
    tier: PlanTier.Custom,
    apiAccess: true,
    domainSchedulerSettingsMaxRules: 10,
    searchPerformanceMaxDomains: 5,
  },
  {
    name: PlanName.CustomEnterpriseYearly,
    chargeBeePlanId: ChargeBeePlanId.CustomEnterpriseYearly,
    index: 5,
    legacy: false,
    costInCents: 0,
    addonCostInCents: 0,
    currencyCode: 'USD',
    includedRenderedPages: 0,
    chargeBeeAddonId: undefined,
    suggested: false,
    current: false,
    cacheRefreshInterval: [0.25, 30],
    cacheLocation: CacheLocation.both,
    available: false,
    support: Support.high,
    billingPeriod: BillingPeriod.yearly,
    customPlan: true,
    contactUsToUse: false,
    tier: PlanTier.Custom,
    apiAccess: true,
    domainSchedulerSettingsMaxRules: 10,
    searchPerformanceMaxDomains: 5,
  },
  ...tier2024ChargeBeePlans,
  ...tier2025ChargeBeePlans,
];

export const PlanIdToNameMap = {
  [ChargeBeePlanId.Basic]: PlanName.Basic,
  [ChargeBeePlanId.Professional]: PlanName.Professional,
  [ChargeBeePlanId.Startup]: PlanName.Startup,
  [ChargeBeePlanId.Business]: PlanName.Business,
  [ChargeBeePlanId.Enterprise]: PlanName.Enterprise,
  [ChargeBeePlanId.Startup2022]: PlanName.Startup,
  [ChargeBeePlanId.Scaleup2022]: PlanName.Scaleup,
  [ChargeBeePlanId.Enterprise2022]: PlanName.Enterprise,
  [ChargeBeePlanId.CustomEnterprise]: PlanName.CustomEnterprise,
  [ChargeBeePlanId.CustomEnterpriseYearly]: PlanName.CustomEnterpriseYearly,
  [ChargeBeePlanId.Legacy]: PlanName.Legacy,
  [ChargeBeePlanId.LegacyYearly]: PlanName.LegacyYearly,
  [ChargeBeePlanId.Adhoc]: PlanName.Adhoc,
  [ChargeBeePlanId.Lite2024]: PlanName.Lite,
  [ChargeBeePlanId.Essential2024]: PlanName.Essential,
  [ChargeBeePlanId.Advanced2024]: PlanName.Advanced,
  [ChargeBeePlanId.Custom2024]: PlanName.Custom,
  [ChargeBeePlanId.Starter]: PlanName.Starter,
  [ChargeBeePlanId.StarterStaging]: PlanName.StarterStaging,
  [ChargeBeePlanId.GrowthStaging]: PlanName.GrowthStaging,
  [ChargeBeePlanId.Growth]: PlanName.Growth,
  [ChargeBeePlanId.Pro]: PlanName.Pro,
  [ChargeBeePlanId.EnterprisePlus]: PlanName.EnterprisePlus,
  [ChargeBeePlanId.EnterprisePlusYearly]: PlanName.EnterprisePlusYearly,
  [ChargeBeePlanId.CustomEnterprise3Years]: PlanName.CustomEnterprise3Years,
  [ChargeBeePlanId.POC]: PlanName.POC,
};
